/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import S3 from 'react-aws-s3';
import ThreeDotsLoader from '../../../../Components/LoadingDots';
import { CDN } from '../../../../constants';
import { Uploadconfig } from '../../../../redux/helper/upload-config';

function AddResourceModal({
    setAddResourcePopup, addResourcePopup, addResourceDetails, setAddResourceDetails, setCategoryList, categoryList, createResoure, setsubmitSelected, submitSelected, setThreeDotsLoader, threeDotLoader, isEdit, setIsEdit, selectedCategory, setSetselectedCategory, handleClose,
}) {
    const ReactS3Client = new S3(Uploadconfig);
    const [selectCategoryDropdown, setSelectCategoryDropdown] = useState(false);
    const [categorySearchTerm, setCategorySearchTerm] = useState('');

    if (isEdit) {
        useEffect(() => {
            setAddResourceDetails((prevState) => ({
                ...prevState,
                resource_category_id: selectedCategory.resource_category_id,
                resource_category_name: selectedCategory.resource_category_name,
                title: selectedCategory.title,
                description: selectedCategory.description,
                document_type: selectedCategory.document_type,
                document: selectedCategory.document,
                status: selectedCategory.status,
            }));
        }, [isEdit]);
    }

    const InputChange = (e, index) => {
        e.preventDefault();
        const { id, value } = e.target;
        if (value.trim() === '') {
            setAddResourceDetails((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            setAddResourceDetails((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
    };

    const categorySearchHandler = (value) => {
        if (categorySearchTerm === '') {
            return value;
        } if ((value.name).toLowerCase().includes(categorySearchTerm.toLowerCase())) {
            return value;
        }
    };
    const handleUploadedFiles = (val, key, files) => {
        const data = { ...addResourceDetails };
        data.document = val;
        data.document_type = files[0].type;
        setAddResourceDetails(data);
    };

    const handleUploadDoc = (e, key) => {
        const { files } = e.target;
        if (files.length === 0) {
            return;
        }
        ReactS3Client.uploadFile(files[0], files[0].name, files[0].type)
            .then((data) => {
                handleUploadedFiles(data.key, key, files);
            })
            .catch((err) =>
            // handleUploadedFiles('eub/ed0ef5a-f27-a510-4d6-c4ae8c42c77c/sample(1).pdf',key);
            // setspinner('');
                err);
    };

    const handleDelete = () => {
        const temp = { ...addResourceDetails };
        temp.document = '';
        setAddResourceDetails(temp);
    };

    return (
        <div className={`modal fade fixed top-0 left-0 ${addResourcePopup ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="add-resource-modal" tabIndex="-1" aria-labelledby="exampleModalCenterTitle" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative min-w-[449px] max-w-[449px] pointer-events-none" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative py-[26px]">
                        <h5 className="text-xs4 font-semibold leading-normal text-[#090406] email" id="exampleModalScrollableLabel">
                            {isEdit ? 'Edit Resource' : 'Add Resource'}
                        </h5>
                        <button
                            type="button"
                            className="absolute top-5 right-3"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => { setAddResourcePopup(false); handleClose(); }}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative px-[46px]">
                        <div className="relative w-full">
                            <input
                                type="text"
                                id="title"
                                className="h-12 w-full rounded-lg outline-0 error2 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3"
                                autoComplete="off"
                                value={addResourceDetails.title}
                                onChange={(e) => {
                                    InputChange(e);
                                    setsubmitSelected(false);
                                }}
                            />
                            <label htmlFor="title" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                Title
                                <span className="text-[#ED1C24]">*</span>
                            </label>
                            {submitSelected && addResourceDetails.title === '' && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">Title is required</p> }
                        </div>
                        <div className="dropdown relative mt-7">
                            <p className="absolute left-3.5 -top-2 px-1 bg-white font-semibold text-xs2 text-[#808285]">
                                Category
                                {' '}
                                <span className="text-[#ED1C24]">*</span>
                            </p>
                            <button
                                className="dropdown-toggle w-full h-10 pl-[18px] error2 text-left border-[#9D9D9D] border font-normal bg-white text-[#808285] text-sm rounded-lg"
                                type="button"
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                onClick={(e) => { setSelectCategoryDropdown(!selectCategoryDropdown); }}
                            >
                                {addResourceDetails.resource_category_name === '' ? <p>Select Category</p> : <p>{addResourceDetails.resource_category_name}</p> }
                                <img src="/images/Chevron-Down-gray.svg" alt="" className="absolute top-4 right-5" />
                            </button>
                            {submitSelected && addResourceDetails.resource_category_name === '' && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">Category is required</p>}
                            {selectCategoryDropdown
                            && (
                                <ul className={`w-full h-auto dropdown-menu bg-white rounded-lg shadow-8xl border border-[#B1B4B7] list1 ${selectCategoryDropdown ? 'show' : 'hidden'} p-3 z-10`} aria-labelledby="dropdownMenuButton1">
                                    <li className=" dropdown-item">
                                        <div className="relative">
                                            <input
                                                type="text"
                                                className="w-full relative h-9 border border-[#66728A] rounded-lg py-2 pl-4 pr-10 text-sm font-normal placeholder:text-[#66728A] text-[#0D1B2A] outline-0"
                                                placeholder="Search"
                                                autoComplete="off"
                                                onChange={(e) => {
                                                    setCategorySearchTerm(e.target.value);
                                                }}

                                            />
                                            <label htmlFor="" />
                                            <img src="/images/search.svg" alt="icon" className="absolute top-3 right-4 cursor-pointer" />
                                        </div>
                                    </li>
                                    <li className="h-[110px] overflow-auto sidebar">
                                        {categoryList.length > 0 && categoryList.filter((value) => categorySearchHandler(value)).map((item) => (
                                            <div
                                                className="dropdown-item relative bg-[#FFFFFF] h-[30px] mt-2 cursor-pointer"
                                                onClick={() => {
                                                    setAddResourceDetails((prevState) => ({
                                                        ...prevState,
                                                        resource_category_name: item.name,
                                                        resource_category_id: item.resource_category_id,
                                                    })); setSelectCategoryDropdown(false);
                                                }}
                                            >
                                                {item.name}
                                            </div>
                                        ))}
                                    </li>

                                </ul>
                            )}
                        </div>
                        <div className="relative w-full mt-6">
                            <textarea
                                type="text"
                                id="description"
                                className="w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal resize-none text-[#090406] px-3 py-5 h-[150px] error2"
                                autoComplete="off"
                                onChange={(e) => {
                                    InputChange(e);
                                    setsubmitSelected(false);
                                }}
                                value={addResourceDetails.description}
                            />
                            <label htmlFor="description" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                Description
                                <span className="text-[#ED1C24]">*</span>
                            </label>
                            {submitSelected && addResourceDetails.description === '' && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">Description is required</p>}
                        </div>
                        <div className="relative mt-3 mb-1 bg-[#555259] rounded-lg pl-[14px] py-3 h-8 cursor-pointer w-[40%]">
                            <span htmlFor="file" className="font-normal text-xs13 text-white absolute left-0 top-2 pl-[14px] cursor-pointer">+ Attach a file*</span>
                            <input
                                type="file"
                                id="file"
                                onChange={(e) => handleUploadDoc(e, 'resource_file')}
                                className="opacity-0 absolute top-0 left-0 cursor-pointer w-[100px]"
                            />
                        </div>
                        {submitSelected && addResourceDetails.document === '' && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">File is required</p>}
                        <div>
                            {addResourceDetails.document !== ''
                                && (
                                    <div className="flex align-items">
                                        <div>
                                            {addResourceDetails.document}
                                            <img
                                                src="/images/circle-close.svg"
                                                alt="icon"
                                                className="pr-4 cursor-pointer"
                                                onClick={() => handleDelete()}
                                            />
                                        </div>

                                    </div>
                                )}
                        </div>
                    </div>
                    <div className="flex justify-center my-[22px]">
                        <button
                            type="button"
                            className="rounded-lg font-normal text-sm text-white bg-[#555259] w-[242px] py-3 outline-0"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => createResoure()}
                        >
                            {threeDotLoader ? <div className="ml-[105px]"><ThreeDotsLoader /></div> : (isEdit ? 'Edit Resource' : 'Add Resource')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddResourceModal;
